const Roles = {
  CARRIER: 'carrier',
  SHIPPER: 'user',
  SALES_REP: 'salesRep',
  CUSTOMER_REP: 'customerRep'
};

export default Roles;
